export default "__VITE_ASSET__DM5qSckP__"